import { useContext } from "react";
import { GameStateContext } from "../context/GameStateContext";

export const useGameState = () => {
    const {state, setState, points, addPoints, level, playerId, resetGame} = useContext(GameStateContext);
    return {
        gameState: state,
        setGameState: setState,
        points,
        addPoints,
        level,
        playerId,
        resetGame,
    }
}
